import { createSystem, defaultConfig, defineRecipe, defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy, segmentGroupAnatomy, tabsAnatomy } from '@chakra-ui/react/anatomy';

export const system = createSystem(defaultConfig, {
    theme: {
        semanticTokens: {
            colors: {
                blue: {
                    solid: { value: '{colors.blue.600}' },
                    // contrast: { value: '{colors.blue.50}' },
                },
                green: {
                    solid: { value: '{colors.green.600}' },
                    // contrast: { value: '{colors.green.950}' },
                },
                red: {
                    solid: { value: '{colors.red.600}' },
                    // contrast: { value: '{colors.red.950}' },
                },
            },
        },
        recipes: {
            button: defineRecipe({
                base: { borderRadius: 'md' },
                defaultVariants: { size: 'md', variant: 'solid' },
            }),
        },
        slotRecipes: {
            segmentGroup: defineSlotRecipe({
                slots: segmentGroupAnatomy.keys(),
                base: {
                    root: {
                        colorPalette: 'blue',
                        '--segment-radius': 'radii.md',
                        '--segment-indicator-bg': 'colors.colorPalette.solid',
                        '--segment-indicator-shadow': 'shadows.md',
                        boxShadow: 'md',
                        minW: 0,
                        maxW: '100%',
                        overflowX: 'auto',
                    },
                    item: {
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                        color: 'fg.muted',
                        focusRingOffset: '-2px',
                        _checked: { color: 'colorPalette.contrast', fontWeight: 'semibold' },
                        '&[data-state=checked][data-ssr]': {
                            bg: 'colorPalette.solid',
                            shadow: 'var(--segment-indicator-shadow)',
                        },
                    },
                },
                defaultVariants: { size: 'md' },
            }),
            dialog: defineSlotRecipe({
                slots: dialogAnatomy.keys(),
                base: { footer: { gap: 2, flexWrap: 'wrap' } },
            }),
            tabs: defineSlotRecipe({
                slots: tabsAnatomy.keys(),
                base: {
                    root: { colorPalette: 'blue', minW: 0 },
                    list: { overflowX: 'auto', maxW: '100%' },
                    trigger: {
                        flexShrink: 0,
                        whiteSpace: 'nowrap',
                        _selected: { fontWeight: 'bold' },
                        _focusVisible: { outlineOffset: '-2px' },
                    },
                },
                defaultVariants: { variant: 'outline', size: 'md' },
            }),
        },
    },
});
